export interface ImagePair {
  left: string;
  right: string;
  title?: string;
  video_url?: string;
  video_display_mode?: string;
}

export interface SectionData {
  slug: string;
  name: string;
  pairs: ImagePair[];
}

const pic = (seed: string) => `https://picsum.photos/seed/${seed}/800/1080`;

export const homeGallery: ImagePair[] = [
  { left: pic('mostra-h1l'), right: pic('mostra-h1r') },
  { left: pic('mostra-h2l'), right: pic('mostra-h2r') },
  { left: pic('mostra-h3l'), right: pic('mostra-h3r') },
  { left: pic('mostra-h4l'), right: pic('mostra-h4r') },
  { left: pic('mostra-h5l'), right: pic('mostra-h5r') },
];

export const sections: SectionData[] = [
  {
    slug: 'retratos',
    name: 'Retratos',
    pairs: [
      { left: pic('ret1l'), right: pic('ret1r'), title: 'Silêncio Interior' },
      { left: pic('ret2l'), right: pic('ret2r'), title: 'Fragmentos' },
      { left: pic('ret3l'), right: pic('ret3r'), title: 'Pele e Luz' },
      { left: pic('ret4l'), right: pic('ret4r'), title: 'Ausência' },
      { left: pic('ret5l'), right: pic('ret5r'), title: 'Olhar Distante' },
    ],
  },
  {
    slug: 'artes',
    name: 'Artes',
    pairs: [
      { left: pic('art1l'), right: pic('art1r'), title: 'Geometria Viva' },
      { left: pic('art2l'), right: pic('art2r'), title: 'Cor e Forma' },
      { left: pic('art3l'), right: pic('art3r'), title: 'Matéria Bruta' },
      { left: pic('art4l'), right: pic('art4r'), title: 'Tempo Suspenso' },
      { left: pic('art5l'), right: pic('art5r'), title: 'Rastro' },
    ],
  },
  {
    slug: 'exposicoes',
    name: 'Exposições',
    pairs: [
      { left: pic('exp1l'), right: pic('exp1r'), title: 'Mostra Inaugural' },
      { left: pic('exp2l'), right: pic('exp2r'), title: 'Entre Paredes' },
      { left: pic('exp3l'), right: pic('exp3r'), title: 'Galeria Aberta' },
      { left: pic('exp4l'), right: pic('exp4r'), title: 'Curadoria Negra' },
      { left: pic('exp5l'), right: pic('exp5r'), title: 'Fim de Ciclo' },
    ],
  },
  {
    slug: 'galerias',
    name: 'Galerias',
    pairs: [
      { left: pic('gal1l'), right: pic('gal1r'), title: 'Espaço Branco' },
      { left: pic('gal2l'), right: pic('gal2r'), title: 'Cubo' },
      { left: pic('gal3l'), right: pic('gal3r'), title: 'Nave' },
      { left: pic('gal4l'), right: pic('gal4r'), title: 'Subsolo' },
      { left: pic('gal5l'), right: pic('gal5r'), title: 'Terraço' },
    ],
  },
];

export const getSectionBySlug = (slug: string): SectionData | undefined =>
  sections.find((s) => s.slug === slug);
